import { useEffect, useRef, useState } from "react";

interface UseNotificationObserverProps {
  notifications: any[];
  user: any;
  readNotification: (params: any) => Promise<any>;
  isActive: boolean;
  containerRef?: React.RefObject<HTMLElement>;
}

export const useNotificationObserver = ({
  notifications,
  user,
  readNotification,
  isActive,
  containerRef,
}: UseNotificationObserverProps) => {
  const [visibleNotifications, setVisibleNotifications] = useState<Set<string>>(
    new Set()
  );
  const notificationTimers = useRef<Map<string, NodeJS.Timeout>>(new Map());
  const pendingReadIds = useRef<Set<string>>(new Set());
  const batchTimer = useRef<NodeJS.Timeout | null>(null);

  // const sendBatchedReadNotifications = () => {
  //   if (pendingReadIds.current.size > 0) {
  //     const idsArray = Array.from(pendingReadIds.current);
  //     if (user && (user.id || user.userId)) {
  //       const userId = user.id || user.userId;
  //       readNotification({ ids: idsArray, read: 1 });
  //     }
  //     pendingReadIds.current.clear();
  //   }
  // };

  // useEffect(() => {
  //   if (!isActive || !notifications) {
  //     return;
  //   }
  //   if (containerRef?.current) {
  //     const unreadNotifications = notifications.filter((n: any) => n.actionable === 0 && n.read === 0);
  //     if (unreadNotifications.length) {
  //       const timer = setTimeout(() => {
  //         const ids = unreadNotifications.map((n: any) => n.id);
  //         if (user && (user.id || user.userId)) {
  //           const userId = user.id || user.userId;
  //           readNotification({ ids, read: 1, user: userId });
  //         }
  //       }, 5000);
  //       return () => clearTimeout(timer);
  //     }
  //   }

  //   const observer = new IntersectionObserver(
  //     (entries) => {
  //       entries.forEach((entry) => {
  //         const notificationId = entry.target.getAttribute('data-notification-id');
  //         if (!notificationId) return;
  //         if (entry.isIntersecting) {
  //           setVisibleNotifications((prev) => new Set(prev).add(notificationId));
  //           const notification = notifications?.find((n: any) => n.id === notificationId);
  //           if (notification && notification.actionable === 0 && notification.read === 0) {
  //             const timer = setTimeout(() => {
  //               pendingReadIds.current.add(notificationId);
  //               if (batchTimer.current) {
  //                 clearTimeout(batchTimer.current);
  //               }
  //               batchTimer.current = setTimeout(() => {
  //                 sendBatchedReadNotifications();
  //               }, 1000);
  //             }, 5000);
  //             notificationTimers.current.set(notificationId, timer);
  //           }
  //         } else {
  //           setVisibleNotifications((prev) => {
  //             const newSet = new Set(prev);
  //             newSet.delete(notificationId);
  //             return newSet;
  //           });
  //           const timer = notificationTimers.current.get(notificationId);
  //           if (timer) {
  //             clearTimeout(timer);
  //             notificationTimers.current.delete(notificationId);
  //           }
  //         }
  //       });
  //     },
  //     {
  //       threshold: 0.1,
  //       rootMargin: '0px 0px -20px 0px',
  //       root: containerRef?.current || null,
  //     },
  //   );

  //   const setupObserver = () => {
  //     const querySelector = containerRef?.current || document;
  //     const notificationElements = querySelector.querySelectorAll('[data-notification-id]');
  //     notificationElements.forEach((element) => {
  //       observer.observe(element);
  //     });
  //   };

  //   const timeoutId = setTimeout(setupObserver, 300);

  //   return () => {
  //     clearTimeout(timeoutId);
  //     if (batchTimer.current) {
  //       clearTimeout(batchTimer.current);
  //     }
  //     notificationTimers.current.forEach((timer) => clearTimeout(timer));
  //     notificationTimers.current.clear();
  //     pendingReadIds.current.clear();
  //     observer.disconnect();
  //   };
  // }, [isActive, notifications, user, readNotification, containerRef]);

  return {
    visibleNotifications,
  };
};
